import React, { Component } from 'react';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';


export class SenderRedMessagePage extends React.Component {

    constructor(props) {
        super(props);
        this.refFileInputSmallImg = React.createRef();
        this.refFileInputBigImg = React.createRef();
    }

    render() {
        return (
            <div className='whiteBlock' style={{'marginTop':'5em', 'width':'82em' }}>  
                    <div className='whiteBlockTitle'>
                    <BeautifulCircleIcon/> 
                    <div className="whiteBlockTitleSpan">
                        Редактирование рассылки
                        </div>
                    </div> 

            <div className= 'inputsBlock'>
                        
            
        
        
            <div className= 'red_msg_inputsBlock_block' >
                    <div className= 'whiteBlockTextInputBlock_label'>
        
                        Введите название рассылки
                    </div>
        
                    <input  onChange={this.props.updateMailingName} value={this.props.mailing_name}  type='text' />
        
        
            </div>
            
            <div className= 'red_msg_inputsBlock_block' >
                    <div className= 'whiteBlockTextInputBlock_label'>
        
                        Введите основной текст
                    </div>
        
                    <textarea onChange={this.props.updateText} value={this.props.text} > 
        
                    </textarea>
        
        
            </div>
            
            <div className= 'red_msg_inputsBlock_block inputsBlock_block'>
                    <div className= 'whiteBlockTextInputBlock_label'>
        
                    Загрузите изображение
                    </div>
        
                    <div onClick={(e) => {
                            this.refFileInputBigImg.current.click()
                        }}  className='inputsBlock_block_addPhoto'>
                        { this.props.photo == null ? 
                        <span className='plusIcon'> <span className="plusIconSpan">+</span> </span> 
                        : 
                        <img src={this.props.photo}/>} 
                    </div>
                    
                    <input onChange={this.props.handleInputChangePhoto} 
                    className='hidden' 
                    ref={this.refFileInputBigImg} 
                    type='file' />
        
            </div>
            
            
            <div className= 'red_msg_inputsBlock_block' style={{textAlign: 'right'}}>
                   
                    <a href='#' onClick={this.props.doSave} className='whiteBlockButton'>Сохранить </a>
                    {/*<div className="finishButton">
                            <a href='#'> Завершить редактирование </a>
                        </div> */}
                    
            </div>
            
        
        </div>  
        </div>
        )
                
    }
}